module.exports = __webpack_public_path__ + "img/edit-icon.d3f990e7.svg";